<template>
    <v-container v-if="!isAuthenticated" fluid fill-height class="home">
        <v-layout row justify-center>
            <v-flex xs12 sm10 elevation-0>
                <div class="sub-window">
                    <v-container pa-1 grid-list-md>
                        <v-layout row align-center>
                            <v-flex xs12>
                                <v-card
                                    v-if="!isAuthenticated"
                                    class="mx-auto transparent"
                                    width="100%"
                                    elevation="0"
                                >
                                    <!-- 50,  CB, C4-->
                                    <v-card-text
                                        class="cyan--text text--accent-2 headline text-center"
                                    >
                                        <img
                                            height="170"
                                            :src="inteligenciaEjecutivaLogo1"
                                        />
                                        <br />
                                        <b
                                            >Talentwise SC, México, Consultoría
                                            empresarial</b
                                        >
                                    </v-card-text>

                                    <!-- Sección para Inicio de Sesión, visible únicamente en ventanas sm y menores
                                    (para ventanas mayores el logueo es desde SideNavigation):-->
                                    <v-card-text
                                        v-if="!$vuetify.breakpoint.mdAndUp"
                                    >
                                        <div class="login-section">
                                            <v-container>
                                                <v-layout
                                                    align-center
                                                    justify-center
                                                >
                                                    <v-flex xs12>
                                                        <div
                                                            class="tw-green headline font-weight-medium"
                                                        >
                                                            {{
                                                                $t('lbl-login')
                                                            }}
                                                        </div>
                                                    </v-flex>
                                                </v-layout>

                                                <v-layout
                                                    row
                                                    justify-space-around
                                                >
                                                    <v-flex xs12>
                                                        <v-form
                                                            ref="form"
                                                            v-model="valid"
                                                            @submit.prevent
                                                        >
                                                            <v-container>
                                                                <v-layout
                                                                    row
                                                                    justify-space-around
                                                                >
                                                                    <v-flex
                                                                        xs10
                                                                    >
                                                                        <v-text-field
                                                                            color="cyan darken-4"
                                                                            prepend-icon="mdi-account"
                                                                            name="email"
                                                                            :label="
                                                                                $t(
                                                                                    'lbl-email'
                                                                                )
                                                                            "
                                                                            type="email"
                                                                            v-model="
                                                                                email
                                                                            "
                                                                            :rules="
                                                                                emailRules
                                                                            "
                                                                            required
                                                                            align-self-center
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>

                                                                <v-layout
                                                                    row
                                                                    justify-space-around
                                                                >
                                                                    <v-flex
                                                                        xs10
                                                                    >
                                                                        <v-text-field
                                                                            color="cyan darken-4"
                                                                            prepend-icon="mdi-lock"
                                                                            name="password"
                                                                            :label="
                                                                                $t(
                                                                                    'lbl-password'
                                                                                )
                                                                            "
                                                                            type="password"
                                                                            required
                                                                            v-model="
                                                                                password
                                                                            "
                                                                            :append-icon="
                                                                                e1
                                                                                    ? 'mdi-eye-off'
                                                                                    : 'mdi-eye'
                                                                            "
                                                                            @click:append="
                                                                                () =>
                                                                                    (e1 = !e1)
                                                                            "
                                                                            :type="
                                                                                e1
                                                                                    ? 'password'
                                                                                    : 'text'
                                                                            "
                                                                            :rules="
                                                                                passwordRules
                                                                            "
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>

                                                                <v-layout
                                                                    row
                                                                    justify-space-around
                                                                >
                                                                    <v-btn
                                                                        type="submit"
                                                                        @submit.prevent="
                                                                            checkLogin
                                                                        "
                                                                        @click="
                                                                            onSubmit
                                                                        "
                                                                        :class="{
                                                                            'cyan darken-3 white--text': valid,
                                                                            disabled: !valid,
                                                                        }"
                                                                        >{{
                                                                            $t(
                                                                                'btn-ok'
                                                                            )
                                                                        }}</v-btn
                                                                    >
                                                                </v-layout>
                                                            </v-container>
                                                        </v-form>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </div>
                                    </v-card-text>
                                    <!-- Fin de Sección para Inicio de Sesión, visible únicamente en ventanas sm y menores -->
                                    <v-card-text
                                        class="teal--text text--lighten-5 body-1 text-left"
                                    >
                                        <template>
                                            <p
                                                v-html="$t('welcomeMessage')"
                                            ></p>
                                        </template>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <!-- Modal para informar que el usuario o el password son incorrectos: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="failedLogin"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Información no
                                            Válida</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-alert-circle-outline</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >Usuario o contraseña no
                                                    válidos.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="failedLogin = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que el usuario o el password son incorrectos *********************************** -->

                        <!-- Modal para informar que el usuario no está activo: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="inactiveUser"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Usuario inactivo</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>error_outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                    >El usuario no está activo
                                                    en el sistema.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="inactiveUser = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que el usuario no está activo *********************************** -->
                    </v-container>
                </div>
                <v-footer absolute color="black" dark>
                    <v-spacer></v-spacer>
                    <div>
                        &copy; TalentWise México, S.A. de C.V. &nbsp;
                        {{ new Date().getFullYear() }} &nbsp; v. {{ version }}
                    </div>
                </v-footer>
            </v-flex>
        </v-layout>
    </v-container>
    <v-container v-else fluid fill-height class="home"></v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    data() {
        return {
            valid: false,
            e1: true,
            password: '',
            passwordRules: [(v) => !!v || 'Introduzca la contraseña'],
            email: '',
            emailRules: [
                (v) => !!v || 'Introduzca su correo electrónico',
                (v) =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    'Introduzca un correo válido',
            ],
        };
    },

    created() {
        //console.log('Home created');
        //console.log('route = ', this.$route);
        //this.$store.dispatch('tryAutoLogin');
        //this.$i18n.locale = 'es'; Parece que esto no es necesario
    },
    methods: {
        onSubmit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('login', {
                    email: this.email,
                    password: this.password,
                });
                this.email = '';
                this.password = '';
                this.e1 = true;
                this.drawer = false;
            }
        },
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'inteligenciaEjecutivaLogo',
            'inteligenciaEjecutivaLogo1',
            'isAuthenticated',
            'version',
        ]),
        failedLogin: {
            get() {
                return this.$store.getters.failedLogin;
            },
            set(failedLogin) {
                this.$store.dispatch('updateFailedLogin', failedLogin);
            },
        },
        inactiveUser: {
            get() {
                return this.$store.getters.inactiveUser;
            },
            set(inactiveUser) {
                this.$store.dispatch('updateInactiveUser', inactiveUser);
            },
        },
        
        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
    },
};
</script>

<i18n>
{
    "es": {
        "welcomeMessage": "Bienvenido a <span style='color:rgb(24, 255, 255);'> <b>retroalimentame.com</b></span>, una plataforma de apoyo a organizaciones y profesionales de <span style='color:rgb(24, 255, 255);'><b>Recursos Humanos</b> </span> que necesiten trabajar procesos de desarrollo ejecutivo, equipos de trabajo y desarrollo organizacional. <br /> <br />La plataforma fue diseñada y es continuamente actualizada con modelos de diagnóstico que permiten facilitar intervenciones grupales e individuales de impacto inmediato en sus proyectos. <br /> <br />Si necesita más detalle sobre la plataforma y nuestros procesos de consultoría no dude en contactarnos.<br /><br />"
    },
    
    "en": {
        "welcomeMessage": "Welcome to <span style='color:rgb(24, 255, 255);'> <b>retroalimentame.com</b></span>, a support platform for organizations and <span style='color:rgb(24, 255, 255);'><b>Human Resources</b> </span> professionals who need to work on executive development processes, work teams and organizational development. <br /> <br />The platform was designed and is continually updated with diagnostic models that facilitate group and individual interventions with immediate impact on your projects. <br /> <br />If you need more details about the platform and our consulting processes, do not hesitate to contact us. <br /><br />"
    }
}
</i18n>

<style scoped>
.home {
    /* background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg'); */
    /*background: url('../assets/ben-rosett-WdJkXFQ4VHY-unsplash.jpg');*/
    /* background: url('../assets/background3.jpg'); */
    background: url('../assets/hunters-race-MYbhN8KaaEc-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}
.sub-window {
    /* background: rgba(89, 111, 133, 0.7); */
    background: rgba(0, 0, 0, 0.7);
    /* background: rgba(255, 255, 255, 0.5); */
}
.login-section {
    background: rgba(238, 238, 238, 0.85);
}
.tw-green {
    color: #006064;
    /* cyan darken-4 */
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
